import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { Cin7ListResponse, Cin7SaleSummary } from "@/api/dtos";
import type { SaleSummary } from "./_models/Sale";
import { toSaleSummaryFromCin7SaleSummary } from "./_transformers/toSaleSummaryFromCin7SaleSummary";

type SaleListResponse = Cin7ListResponse<"SaleList", Cin7SaleSummary>;

const PAGE_LIMIT = 100;

/** The Cin7 sale with this exact order number, or null; searches saleList (a fuzzy match) and keeps the exact one. */
export const getSaleByOrderNumberApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSaleByOrderNumber: builder.query<SaleSummary | null, string>({
      queryFn: async (orderNumber) => {
        try {
          const res = await axios.get<SaleListResponse>(
            `${backendBase()}/cin7/sale-list`,
            {
              params: { Page: 1, Limit: PAGE_LIMIT, Search: orderNumber },
              headers: { Accept: "application/json" },
            },
          );
          const match = res.data.SaleList.find((x) => x.OrderNumber === orderNumber);
          if (!match) {
            return { data: null };
          }
          const sale = toSaleSummaryFromCin7SaleSummary(match);
          return { data: sale };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getSaleByOrderNumber = getSaleByOrderNumberApi.endpoints.getSaleByOrderNumber;
